import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { DANGER_STATUS_COLOR } = constants;

let styles = {
  base: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    marginBottom: 30
  },
  baseCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: 10
  },
  parent: {
    position: 'relative'
  },
  label: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: '0.8em',
    marginBottom: 6
  },
  labelCheckbox: {
    textTransform: 'capitalize',
    fontSize: '1em',
    fontWeight: 500
  },
  radioInput: {
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: 30
  },
  radioGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    flexShrink: 0
  },
  error: {
    fontSize: '0.9em',
    fontWeight: 500,
    paddingTop: 3,
    paddingLeft: 1,
    color: DANGER_STATUS_COLOR
  },
  halfWidth: {
    width: '50%'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/formfield/FormField.styles.js